import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';

import {AsyncHandlerOf} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../../../shared/ui/src/components/buttons/buttonConstants';

/*
 * Constants.
 */

const maxCardsMergableAtOnce = 20;
const minCardsMergableAtOnce = 1;

/*
 * Props.
 */

interface ContactsTableMergeActionProps {
  cardIds: ReadonlyArray<number>;
  openSidePanelAsync: AsyncHandlerOf<ReadonlyArray<number>>;
}

/*
 * Component.
 */

export const ContactsTableMergeAction: FC<ContactsTableMergeActionProps> = (props) => {
  const {cardIds, openSidePanelAsync} = props;
  const isDisabled = computeIsDisabled(cardIds);

  return (
    <Button
      variant={ButtonVariantsEnum.SECONDARY}
      isDisabled={isDisabled}
      renderTooltip={() => renderDisabledMessage(cardIds)}
      onClick={() => openSidePanelAsync(cardIds)}
    >
      <Trans id="contact-manager-table-multi-select-actions-merge">Merge</Trans>
    </Button>
  );
};

/*
 * Helpers.
 */

function computeIsDisabled(selectedCardIds: ReadonlyArray<number>) {
  return selectedCardIds.length <= minCardsMergableAtOnce || selectedCardIds.length > maxCardsMergableAtOnce;
}

function renderDisabledMessage(selectedCardIds: ReadonlyArray<number>): ReactNode {
  if (selectedCardIds.length > maxCardsMergableAtOnce) {
    return (
      <Trans id="contacts-manager-merge-button-disabled-max-cards-tooltip">
        Cannot merge more than {maxCardsMergableAtOnce} contacts at once
      </Trans>
    );
  }
  return null;
}
